var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "common-banner"
  }, [_c('img', {
    style: _vm.rate ? {
      minHeight: "".concat(100 / _vm.rate, "vw")
    } : {},
    attrs: {
      "src": _vm.src,
      "alt": ""
    }
  }), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }